import moment from 'moment';

export const formatDate = (date: number, formatType: 'long' | 'short') => {
  const formatString =
    formatType === 'long' ? 'DD-MM-YYYY, HH:mm' : 'DD-MM-YYYY';
  const momentTime = moment.unix(date);

  return momentTime.isValid() ? momentTime.format(formatString) : 'unknown';
};
